import {SelectItem} from "@heroui/react";
import PAutocomplete from "./PAutocomplete.tsx";

export const CountriesMap = {
    US: 'United States',
    AU: 'Australia',
    CA: 'Canada',
    GB: 'United Kingdom',
    NZ: 'New Zealand',
    AF: 'Afghanistan',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas, The',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    VG: 'Virgin Islands, British',
    BN: 'Brunei',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Cabo Verde',
    KH: 'Cambodia',
    CM: 'Cameroon',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CD: 'Congo (Kinshasa)',
    CG: 'Congo (Brazzaville)',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Cyprus',
    CZ: 'Czechia',
    CI: 'Côte d\'Ivoire',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    SZ: 'Eswatini',
    ET: 'Ethiopia',
    FK: 'Falkland Islands (Islas Malvinas)',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern And Antarctic Lands',
    GA: 'Gabon',
    GM: 'Gambia, The',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island / McDonald',
    VA: 'Holy See',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Laos',
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MU: 'Mauritius',
    MR: 'Mauritania',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia, Federated States Of',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NC: 'New Caledonia',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    KP: 'Korea, North',
    MK: 'North Macedonia',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestine',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn Islands',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    RE: 'Réunion',
    BL: 'Saint Barthélemy',
    KN: 'Saint Kitts and Nevis',
    MF: 'Saint Martin',
    PM: 'Saint Pierre and Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    SH: 'Saint Helena, Ascension, And Tristan Da Cunha',
    LC: 'Saint Lucia',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    KR: 'Korea, South',
    GS: 'South Georgia And South Sandwich Islands',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    UY: 'Uruguay',
    VI: 'U.S. Virgin Islands',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Viet Nam',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
    AX: 'Åland Islands',
}

const PSelectCountry = ({label, onValueChange, ...params}) => {
    return <PAutocomplete
        name="Country"
        labelPlacement="outside"
        placeholder={" "}
        label={label}
        defaultSelectedKey={params.defaultSelectedKey}
        selectedKey={params.selectedKeys?.[0]}
        onSelectionChange={(e) => {
            onValueChange(e);
        }}
        {...params}
    >
        <SelectItem key="US" data-geo="United States">UNITED STATES</SelectItem>
        <SelectItem key="AU" data-geo="Australia">AUSTRALIA</SelectItem>
        <SelectItem key="CA" data-geo="Canada">CANADA</SelectItem>
        <SelectItem key="GB" data-geo="United Kingdom">UNITED KINGDOM</SelectItem>
        <SelectItem key="NZ" data-geo="New Zealand">NEW ZEALAND</SelectItem>

        <SelectItem key="AF">Afghanistan</SelectItem>
        <SelectItem key="AL">Albania</SelectItem>
        <SelectItem key="DZ">Algeria</SelectItem>
        <SelectItem key="AS">American Samoa</SelectItem>
        <SelectItem key="AD">Andorra</SelectItem>
        <SelectItem key="AO">Angola</SelectItem>
        <SelectItem key="AI">Anguilla</SelectItem>
        <SelectItem key="AQ">Antarctica</SelectItem>
        <SelectItem key="AG">Antigua and Barbuda</SelectItem>
        <SelectItem key="AR">Argentina</SelectItem>
        <SelectItem key="AM">Armenia</SelectItem>
        <SelectItem key="AW">Aruba</SelectItem>
        <SelectItem key="AT">Austria</SelectItem>
        <SelectItem key="AZ">Azerbaijan</SelectItem>
        <SelectItem key="BS" data-geo="Bahamas, The">Bahamas</SelectItem>
        <SelectItem key="BH">Bahrain</SelectItem>
        <SelectItem key="BD">Bangladesh</SelectItem>
        <SelectItem key="BB">Barbados</SelectItem>
        <SelectItem key="BY">Belarus</SelectItem>
        <SelectItem key="BE">Belgium</SelectItem>
        <SelectItem key="BZ">Belize</SelectItem>
        <SelectItem key="BJ">Benin</SelectItem>
        <SelectItem key="BM">Bermuda</SelectItem>
        <SelectItem key="BT">Bhutan</SelectItem>
        <SelectItem key="BO">Bolivia</SelectItem>
        <SelectItem key="BQ">Bonaire, Sint Eustatius and Saba</SelectItem>
        <SelectItem key="BA">Bosnia and Herzegovina</SelectItem>
        <SelectItem key="BW">Botswana</SelectItem>
        <SelectItem key="BV">Bouvet Island</SelectItem>
        <SelectItem key="BR">Brazil</SelectItem>
        <SelectItem key="IO">British Indian Ocean Territory</SelectItem>
        <SelectItem key="VG" data-geo="Virgin Islands, British">British Virgin Islands</SelectItem>
        <SelectItem key="BN" data-geo="Brunei">Brunei Darussalam</SelectItem>
        <SelectItem key="BG">Bulgaria</SelectItem>
        <SelectItem key="BF">Burkina Faso</SelectItem>
        <SelectItem key="BI">Burundi</SelectItem>
        <SelectItem key="CV">Cabo Verde</SelectItem>
        <SelectItem key="KH">Cambodia</SelectItem>
        <SelectItem key="CM">Cameroon</SelectItem>
        <SelectItem key="KY">Cayman Islands</SelectItem>
        <SelectItem key="CF">Central African Republic</SelectItem>
        <SelectItem key="TD">Chad</SelectItem>
        <SelectItem key="CL">Chile</SelectItem>
        <SelectItem key="CN">China</SelectItem>
        <SelectItem key="CX">Christmas Island</SelectItem>
        <SelectItem key="CC">Cocos (Keeling) Islands</SelectItem>
        <SelectItem key="CO">Colombia</SelectItem>
        <SelectItem key="KM">Comoros</SelectItem>
        <SelectItem key="CD">Congo (Kinshasa)</SelectItem>
        <SelectItem key="CG">Congo (Brazzaville)</SelectItem>
        <SelectItem key="CK">Cook Islands</SelectItem>
        <SelectItem key="CR">Costa Rica</SelectItem>
        <SelectItem key="HR">Croatia</SelectItem>
        <SelectItem key="CU">Cuba</SelectItem>
        <SelectItem key="CW">Curaçao</SelectItem>
        <SelectItem key="CY">Cyprus</SelectItem>
        <SelectItem key="CZ">Czechia</SelectItem>
        <SelectItem key="CI">Côte d'Ivoire</SelectItem>
        <SelectItem key="DK">Denmark</SelectItem>
        <SelectItem key="DJ">Djibouti</SelectItem>
        <SelectItem key="DM">Dominica</SelectItem>
        <SelectItem key="DO">Dominican Republic</SelectItem>
        <SelectItem key="EC">Ecuador</SelectItem>
        <SelectItem key="EG">Egypt</SelectItem>
        <SelectItem key="SV">El Salvador</SelectItem>
        <SelectItem key="GQ">Equatorial Guinea</SelectItem>
        <SelectItem key="ER">Eritrea</SelectItem>
        <SelectItem key="EE">Estonia</SelectItem>
        <SelectItem key="SZ">Eswatini</SelectItem>
        <SelectItem key="ET">Ethiopia</SelectItem>
        <SelectItem key="FK" data-geo="Falkland Islands (Islas Malvinas)">Falkland Islands [Malvinas]</SelectItem>
        <SelectItem key="FO">Faroe Islands</SelectItem>
        <SelectItem key="FJ">Fiji</SelectItem>
        <SelectItem key="FI">Finland</SelectItem>
        <SelectItem key="FR">France</SelectItem>
        <SelectItem key="GF">French Guiana</SelectItem>
        <SelectItem key="PF">French Polynesia</SelectItem>
        <SelectItem key="TF" data-geo="French Southern And Antarctic Lands">French Southern Territories</SelectItem>
        <SelectItem key="GA">Gabon</SelectItem>
        <SelectItem key="GM" data-geo="Gambia, The">Gambia</SelectItem>
        <SelectItem key="GE">Georgia</SelectItem>
        <SelectItem key="DE">Germany</SelectItem>
        <SelectItem key="GH">Ghana</SelectItem>
        <SelectItem key="GI">Gibraltar</SelectItem>
        <SelectItem key="GR">Greece</SelectItem>
        <SelectItem key="GL">Greenland</SelectItem>
        <SelectItem key="GD">Grenada</SelectItem>
        <SelectItem key="GP">Guadeloupe</SelectItem>
        <SelectItem key="GU">Guam</SelectItem>
        <SelectItem key="GT">Guatemala</SelectItem>
        <SelectItem key="GG">Guernsey</SelectItem>
        <SelectItem key="GN">Guinea</SelectItem>
        <SelectItem key="GW">Guinea-Bissau</SelectItem>
        <SelectItem key="GY">Guyana</SelectItem>
        <SelectItem key="HT">Haiti</SelectItem>
        <SelectItem key="HM">Heard Island / McDonald</SelectItem>
        <SelectItem key="VA">Holy See</SelectItem>
        <SelectItem key="HN">Honduras</SelectItem>
        <SelectItem key="HK">Hong Kong</SelectItem>
        <SelectItem key="HU">Hungary</SelectItem>
        <SelectItem key="IS">Iceland</SelectItem>
        <SelectItem key="IN">India</SelectItem>
        <SelectItem key="ID">Indonesia</SelectItem>
        <SelectItem key="IR">Iran</SelectItem>
        <SelectItem key="IQ">Iraq</SelectItem>
        <SelectItem key="IE">Ireland</SelectItem>
        <SelectItem key="IM">Isle of Man</SelectItem>
        <SelectItem key="IL">Israel</SelectItem>
        <SelectItem key="IT">Italy</SelectItem>
        <SelectItem key="JM">Jamaica</SelectItem>
        <SelectItem key="JP">Japan</SelectItem>
        <SelectItem key="JE">Jersey</SelectItem>
        <SelectItem key="JO">Jordan</SelectItem>
        <SelectItem key="KZ">Kazakhstan</SelectItem>
        <SelectItem key="KE">Kenya</SelectItem>
        <SelectItem key="KI">Kiribati</SelectItem>
        <SelectItem key="KW">Kuwait</SelectItem>
        <SelectItem key="KG">Kyrgyzstan</SelectItem>
        <SelectItem key="LA">Laos</SelectItem>
        <SelectItem key="LV">Latvia</SelectItem>
        <SelectItem key="LB">Lebanon</SelectItem>
        <SelectItem key="LS">Lesotho</SelectItem>
        <SelectItem key="LR">Liberia</SelectItem>
        <SelectItem key="LY">Libya</SelectItem>
        <SelectItem key="LI">Liechtenstein</SelectItem>
        <SelectItem key="LT">Lithuania</SelectItem>
        <SelectItem key="LU">Luxembourg</SelectItem>
        <SelectItem key="MO">Macao</SelectItem>
        <SelectItem key="MG">Madagascar</SelectItem>
        <SelectItem key="MW">Malawi</SelectItem>
        <SelectItem key="MY">Malaysia</SelectItem>
        <SelectItem key="MV">Maldives</SelectItem>
        <SelectItem key="ML">Mali</SelectItem>
        <SelectItem key="MT">Malta</SelectItem>
        <SelectItem key="MH">Marshall Islands</SelectItem>
        <SelectItem key="MQ">Martinique</SelectItem>
        <SelectItem key="MU">Mauritius</SelectItem>
        <SelectItem key="MR">Mauritania</SelectItem>
        <SelectItem key="YT">Mayotte</SelectItem>
        <SelectItem key="MX">Mexico</SelectItem>
        <SelectItem key="FM" data-geo="Micronesia, Federated States Of">Micronesia</SelectItem>
        <SelectItem key="MD">Moldova</SelectItem>
        <SelectItem key="MC">Monaco</SelectItem>
        <SelectItem key="MN">Mongolia</SelectItem>
        <SelectItem key="ME">Montenegro</SelectItem>
        <SelectItem key="MS">Montserrat</SelectItem>
        <SelectItem key="MA">Morocco</SelectItem>
        <SelectItem key="MZ">Mozambique</SelectItem>
        <SelectItem key="MM">Myanmar</SelectItem>
        <SelectItem key="NA">Namibia</SelectItem>
        <SelectItem key="NR">Nauru</SelectItem>
        <SelectItem key="NP">Nepal</SelectItem>
        <SelectItem key="NL">Netherlands</SelectItem>
        <SelectItem key="NC">New Caledonia</SelectItem>
        <SelectItem key="NI">Nicaragua</SelectItem>
        <SelectItem key="NE">Niger</SelectItem>
        <SelectItem key="NG">Nigeria</SelectItem>
        <SelectItem key="NU">Niue</SelectItem>
        <SelectItem key="NF">Norfolk Island</SelectItem>
        <SelectItem key="KP" data-geo="Korea, North">North Korea</SelectItem>
        <SelectItem key="MK">North Macedonia</SelectItem>
        <SelectItem key="MP">Northern Mariana Islands</SelectItem>
        <SelectItem key="NO">Norway</SelectItem>
        <SelectItem key="OM">Oman</SelectItem>
        <SelectItem key="PK">Pakistan</SelectItem>
        <SelectItem key="PW">Palau</SelectItem>
        <SelectItem key="PS">Palestine</SelectItem>
        <SelectItem key="PA">Panama</SelectItem>
        <SelectItem key="PG">Papua New Guinea</SelectItem>
        <SelectItem key="PY">Paraguay</SelectItem>
        <SelectItem key="PE">Peru</SelectItem>
        <SelectItem key="PH">Philippines</SelectItem>
        <SelectItem key="PN" data-geo="Pitcairn Islands">Pitcairn</SelectItem>
        <SelectItem key="PL">Poland</SelectItem>
        <SelectItem key="PT">Portugal</SelectItem>
        <SelectItem key="PR">Puerto Rico</SelectItem>
        <SelectItem key="QA">Qatar</SelectItem>
        <SelectItem key="RO">Romania</SelectItem>
        <SelectItem key="RU">Russian Federation</SelectItem>
        <SelectItem key="RW">Rwanda</SelectItem>
        <SelectItem key="RE">Réunion</SelectItem>
        <SelectItem key="BL">Saint Barthélemy</SelectItem>
        <SelectItem key="KN">Saint Kitts and Nevis</SelectItem>
        <SelectItem key="MF" data-geo="Saint Martin">Saint Martin (French part)</SelectItem>
        <SelectItem key="PM">Saint Pierre and Miquelon</SelectItem>
        <SelectItem key="VC">Saint Vincent and the Grenadines</SelectItem>
        <SelectItem key="SH" data-geo="Saint Helena, Ascension, And Tristan Da Cunha">Saint Helena</SelectItem>
        <SelectItem key="LC">Saint Lucia</SelectItem>
        <SelectItem key="WS">Samoa</SelectItem>
        <SelectItem key="SM">San Marino</SelectItem>
        <SelectItem key="ST">Sao Tome and Principe</SelectItem>
        <SelectItem key="SA">Saudi Arabia</SelectItem>
        <SelectItem key="SN">Senegal</SelectItem>
        <SelectItem key="RS">Serbia</SelectItem>
        <SelectItem key="SC">Seychelles</SelectItem>
        <SelectItem key="SL">Sierra Leone</SelectItem>
        <SelectItem key="SG">Singapore</SelectItem>
        <SelectItem key="SX" data-geo="Sint Maarten">Sint Maarten (Dutch part)</SelectItem>
        <SelectItem key="SK">Slovakia</SelectItem>
        <SelectItem key="SI">Slovenia</SelectItem>
        <SelectItem key="SB">Solomon Islands</SelectItem>
        <SelectItem key="SO">Somalia</SelectItem>
        <SelectItem key="ZA">South Africa</SelectItem>
        <SelectItem key="KR" data-geo="Korea, South">South Korea</SelectItem>
        <SelectItem key="GS" data-geo="South Georgia And South Sandwich Islands">South Georgia</SelectItem>
        <SelectItem key="SS">South Sudan</SelectItem>
        <SelectItem key="ES">Spain</SelectItem>
        <SelectItem key="LK">Sri Lanka</SelectItem>
        <SelectItem key="SD">Sudan</SelectItem>
        <SelectItem key="SR">Suriname</SelectItem>
        <SelectItem key="SJ" data-geo="Svalbard">Svalbard and Jan Mayen</SelectItem>
        <SelectItem key="SE">Sweden</SelectItem>
        <SelectItem key="CH">Switzerland</SelectItem>
        <SelectItem key="SY">Syrian Arab Republic</SelectItem>
        <SelectItem key="TW">Taiwan</SelectItem>
        <SelectItem key="TJ">Tajikistan</SelectItem>
        <SelectItem key="TZ">Tanzania</SelectItem>
        <SelectItem key="TH">Thailand</SelectItem>
        <SelectItem key="TL">Timor-Leste</SelectItem>
        <SelectItem key="TG">Togo</SelectItem>
        <SelectItem key="TK">Tokelau</SelectItem>
        <SelectItem key="TO">Tonga</SelectItem>
        <SelectItem key="TT">Trinidad and Tobago</SelectItem>
        <SelectItem key="TN">Tunisia</SelectItem>
        <SelectItem key="TR">Turkey</SelectItem>
        <SelectItem key="TM">Turkmenistan</SelectItem>
        <SelectItem key="TC">Turks and Caicos Islands</SelectItem>
        <SelectItem key="TV">Tuvalu</SelectItem>
        <SelectItem key="UG">Uganda</SelectItem>
        <SelectItem key="UA">Ukraine</SelectItem>
        <SelectItem key="AE">United Arab Emirates</SelectItem>
        <SelectItem key="UY">Uruguay</SelectItem>
        <SelectItem key="VI" data-geo="U.S. Virgin Islands">US Virgin Islands</SelectItem>
        <SelectItem key="UZ">Uzbekistan</SelectItem>
        <SelectItem key="VU">Vanuatu</SelectItem>
        <SelectItem key="VE">Venezuela</SelectItem>
        <SelectItem key="VN">Viet Nam</SelectItem>
        <SelectItem key="WF">Wallis and Futuna</SelectItem>
        <SelectItem key="EH">Western Sahara</SelectItem>
        <SelectItem key="YE">Yemen</SelectItem>
        <SelectItem key="ZM">Zambia</SelectItem>
        <SelectItem key="ZW">Zimbabwe</SelectItem>
        <SelectItem key="AX">Åland Islands</SelectItem>
    </PAutocomplete>
}

export default PSelectCountry;
